import { defineComponent as c, computed as m, createElementBlock as e, openBlock as t, normalizeProps as u, guardReactiveProps as p, unref as n, Fragment as f, renderList as y, createElementVNode as a, toDisplayString as s } from "vue";
import { useBindCx as h } from "@scalar/use-hooks/useBindCx";
import { formatHotkeySymbols as k, getKeyLabel as x } from "./formatHotkey.js";
const _ = {
  "aria-hidden": "true",
  class: "contents"
}, g = { class: "sr-only" }, E = /* @__PURE__ */ c({
  inheritAttrs: !1,
  __name: "ScalarHotkey",
  props: {
    hotkey: {},
    modifier: { default: () => ["Meta"] }
  },
  setup(o) {
    const { cx: i } = h(), d = m(() => k(o.hotkey, o.modifier));
    return (b, v) => (t(), e("div", u(p(
      n(i)(
        "border-(--scalar-background-3) inline-flex gap-0.5 overflow-hidden rounded border text-xxs rounded-b p-1 font-medium uppercase leading-none"
      )
    )), [
      (t(!0), e(f, null, y(d.value, (r, l) => (t(), e("div", { key: l }, [
        a("span", _, s(r), 1),
        a("span", g, s(n(x)(r)), 1)
      ]))), 128))
    ], 16));
  }
});
export {
  E as default
};
